import { useState, type ReactNode } from 'react';
import { cn } from '@shared/lib';

interface TooltipProps {
  text: ReactNode;
  side?: 'top' | 'bottom';
  children: ReactNode;
  className?: string;
}

export function Tooltip({ text, side = 'top', children, className }: TooltipProps) {
  const [open, setOpen] = useState(false);
  return (
    <span
      className={cn('relative inline-flex', className)}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
    >
      {children}
      {open && (
        <span
          className={cn(
            'absolute right-0 z-50 w-[260px] rounded-xl border border-[#2a2a2f] bg-[#0e0e10] px-3.5 py-2.5',
            'text-xs font-normal leading-relaxed text-fg',
            'shadow-[0_12px_32px_-12px_rgba(0,0,0,0.6)]',
            side === 'top' ? 'bottom-[calc(100%+10px)]' : 'top-[calc(100%+10px)]',
          )}
        >
          {text}
        </span>
      )}
    </span>
  );
}
